import {Situacao} from './situacao';
import {Endereco} from './endereco';
import {Parcela} from './parcela';
import {Veiculo} from './veiculo';
import {Empresa} from './empresa';
import {ContratoValor} from './contratoValor';

export class Contrato {
    
    nuTransacao: string;
    nuProtocolo: string;
    cdRetorno: string;
    cdMsgemRetorno: string;
    dsMsgemRetorno: string;
    dsMsgemMainframeRetorno: string;
    nuControle: string;
    nuDocumento: string;
    cdCtrlProcessamento: string;
    textoAutenticacao: string;
    cdIndcdTransacao: string;
    lstMensagem: Array<string>;
    nuContrato: number;
    nuContratoFormatado: string;
    nuCarteira: number;
    nuProduto: number;
    nuLoja: number;
    dtBaseContrato: string;
    dtBaseContratoFormatado: string;
    cdIndPermissao: string;
    cdContrato: number;
    nmProdutoFinanciamento: string;
    tpFinanciamento: string;
    qtDiasAtraso: string;
    registroContratoGravame: string;
    registroContratoGravameFormatado: string;
    servicoPrestadoRevenda: string;
    servicoPrestadoRevendaFormatado: string;
    dsFormaPagamento: string;
    tpContrato: number;
    dtQuitacao: number;
    dtQuitacaoFormatado: string;
    nmConvenio: string;
    flagMostraMensagemEncargo: boolean;
    flagMostraInformacaoEncargo: boolean;
    dtBaseCalculo: string;
    dtBaseCalculoFormatado: string;
    tpPagamento: number;
    nmCobradora: string;
    nmRuaCobradora: string;
    nuRuaCobradora: string;
    nmBairroCobradora: string;
    nmCidadeCobradora: string;
    ufCobradora: string;
    nuDddCobradora: string;
    nuTelCobradora: string;
    nuTelCobradoraCompleto: string;
    nmModalidade: string;
    dtContrato: string;
    nuCalculo: string;
    qtParcelas: number;
    qtParcelasAbertas: number;
    qtParcelasAtrasadas: number;
    cdOrdemParcelasAbertas: string;
    cdIndAcessoria: string;
    cdIndDivergencia: string;
    cdIndCarencia: string;
    cdIndSinalMulta: string;
    dsStatus: string;
    nmSeguro: string;
    cdRegra: string;
    cdRegraOK: string;
    cdMsgemRetornoOK: string;
    flagRegraM4: string;
    flagRegrasExcetoM4: string;
    dsUrlDownload: string;
    exibeRodapeVencida: string;
    exibeRodapeVencidaAssessoria: string;
    indProdAgreg: string;
    situacao: Situacao;
    endereco: Endereco;
    parcela: Parcela;
    veiculo: Veiculo;
    empresa: Empresa;
    contratoValor: ContratoValor;
    listaParcela: Parcela[];
    listaProdutosAgregados: Array<string>;
    listaMensagem: Array<string>;
    dtAtualFormatada: string;
    cdStatusDispSolicit: string;

    constructor() {}
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/contrato.ts